import { ClientConfiguration } from "@/Common/Models/ClientConfiguration";
import { EmployeeTitle } from "@/Common/Models/Employee/Enums/EmployeeTitle";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";
import { AuthenticatorCodeDeliveryMethod } from "@/Common/Models/MultifactorAuthentication/AuthenticatorCodeDeliveryMethod";
import { UnverifiedEmail } from "@/Common/Models/UnverifiedEmail";

class Login {
    public LoggedIn: boolean;
    public SecurityTokenHash: string;
    public SessionId: string;
    public UserId: string;
    public EmployeeType: EmployeeType;
    public EmployeeTitle: EmployeeTitle;
    public IndividualContactId: string;
    public Permissions: string[];
    public Roles: string[];
    public UserLanguageCode: string;
    public IsTempPassWord: boolean;
    public IsNewAdminUser: boolean;
    public ClientConfiguration: ClientConfiguration;
    public SessionDurationMinutes: number;
    public RequiresAcceptAgreement: boolean;
    public SignOnPrintAccess: boolean;
    public FaxAccess: boolean;
    public HasEmails: boolean;
    public UnverifiedEmail: UnverifiedEmail;
    public LastRecoveryEmailPromptDate: Date | null;
    public LastVerifiedEmail: string | null;
    public IsRecoveryEmailRequired: boolean;
    public IsMultifactorAuthenticationRequired: boolean;
    public IsMultifactorAuthenticationEnabled: boolean;
    public MultifactorAuthenticationSetupPromptDates: Date[];
    public HasPinSet: boolean;
    public PreferedFaxAccountNumberId: number;
    public UseMetricSystemAsDefault: boolean;
    public SessionExpiration: Date;
    public WalkmeActivationDate: Date;
    public UserCreationDate: string;
    public GoLiveDate?: Date;
    public CustomPasswordRuleMessage?: LocalizedTextDto;
    public CustomAdminPasswordRuleMessage?: LocalizedTextDto;
    public AuthenticatorCodeError: AuthenticatorCodeError;
    public SendAuthenticatorCodeByEmailToken: string;
    public PasswordValidationRegex?: string;
    public AuthenticatorCodeDeliveryMethod: AuthenticatorCodeDeliveryMethod;
}

/**
 * A status indicating why multifactor authentication (MFA) failed, if applicable.
 */
enum AuthenticatorCodeError {
    /**
     * No error occurred. Either MFA isn't enabled, or a correct MFA code was provided.
     */
    None,

    /**
     * The MFA code is required to login, but wasn't provided.
     */
    Missing,

    /**
     * The MFA code is required to login, but the provided value doesn't match one of the expected codes.
     */
    Invalid
}

class SessionCheck {
    public IsSuccess: boolean;
    public SessionExpirationTime: Date;
}

class AddEmailResponse {
    public EmailAddress: string;
    public ContactPointId: string;
    public IsOkToContact: boolean;
    public IsNotifiedByEmail: boolean;
}

export { AddEmailResponse, AuthenticatorCodeError, Login, SessionCheck };
